import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationInfo, ApplicationInfoService, GeneralConfig, GeneralConfigService } from '@inera/common';

@Component({
  standalone: false,
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  public page: Observable<string>;
  public config: GeneralConfig;
  public applicationInfo: ApplicationInfo;

  constructor(
    private generalConfigService: GeneralConfigService,
    private applicationInfoService: ApplicationInfoService
  ) {}

  ngOnInit(): void {
    this.generalConfigService.getConfig().subscribe(result => {
      this.config = result;
    });

    this.applicationInfoService.getConfig().subscribe(result => {
      this.applicationInfo = result;
    });
  }
}
